/*
 * Sticky Header Actions
 * Maneja el estado de scroll para mostrar/ocultar search bar en header
 */

export const SET_STICKY_HEADER = 'SET_STICKY_HEADER';

export function setStickyHeader(isSticky) {
  return {
    type: SET_STICKY_HEADER,
    payload: {
      isSticky
    }
  };
}
